import { ActionTableSortType } from 'models';
import { Column, SortParams } from '../models';

import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import { TableCell } from '../styled';
import ActionSortTableCell from '../action-sort-table-cell';

import { useStyles } from './style';

type ActionTableHeadProps<Component extends JSX.Element = any> = {
  columns: Column[];
  withCheckbox: boolean;
  withSort: boolean;
  CheckboxComponent: Component;
  CheckboxComponentProps: Component['props'];
  sortParams?: SortParams;
  onChangeSortParams?: (orderBy: string, type: ActionTableSortType) => void;
};

const ActionTableHead: React.FC<ActionTableHeadProps> = (props) => {
  const classes = useStyles();

  const {
    columns,
    withCheckbox,
    CheckboxComponent,
    CheckboxComponentProps,
    withSort,
    sortParams,
    onChangeSortParams,
  } = props;

  return (
    <MuiTableHead>
      <MuiTableRow className={classes.row}>
        {withCheckbox ? (
          <TableCell className={classes.checkboxCell}>
            <CheckboxComponent {...CheckboxComponentProps} />
          </TableCell>
        ) : null}
        {columns.map(
          ({
            accessor,
            align,
            label,
            sortType = 'alphanumeric',
            canSort = true,
            Cell,
          }) => {
            const active = withSort && accessor === sortParams?.orderBy;
            return withSort && canSort ? (
              <ActionSortTableCell
                active={active}
                order={sortParams?.order || 'asc'}
                onChangeSortParams={() =>
                  onChangeSortParams &&
                  onChangeSortParams(accessor as string, sortType)
                }
                style={Cell?.style}
              >
                {label}
              </ActionSortTableCell>
            ) : (
              <TableCell
                key={accessor}
                align={align}
                className={classes.cell}
                style={Cell?.style}
              >
                {label}
              </TableCell>
            );
          }
        )}
      </MuiTableRow>
    </MuiTableHead>
  );
};

export default ActionTableHead;
